import { LuggageOption } from './LuggageOption';
import { StyledLuggageTable } from './styles';

import type { FlightOption } from '@/types/flights';

interface LuggageOptionProps {
  options: FlightOption[];
}

export function LuggageOptions({ options }: LuggageOptionProps) {
  return (
    <StyledLuggageTable>
      {options.map((option) => (
        <LuggageOption key={option.listId} flightOption={option} options={options} />
      ))}
    </StyledLuggageTable>
  );
}
